/* esm.sh - @tweenjs/tween.js@25.0.0 */
export * from "/*@tweenjs/tween.js@25.0.0/esnext/tween.mjs";
export { default } from "/*@tweenjs/tween.js@25.0.0/esnext/tween.mjs";
